const internalUrlsSReach = [];

export const processLink = (
    link: string,
    nodeLookup?: { nodeId: number; path: string }[]
) => {
    if (!link) return `#`;
    if (link.startsWith(`#`)) return link;
    if (link.includes(`internal:`)) {
        return link.replace(`internal:`, ``);
    }
    if (nodeLookup && link.includes(`entity:node`)) {
        const nodeId = link.replace(`entity:node/`, ``);
        const match = nodeLookup.find(
            (node) => node.nodeId.toString() === nodeId
        );
        if (match) {
            return match.path;
        }
        return `/404`;
    }
    if (link.includes(`acquia-sites.com`) || link.includes(`sites/default/`)) {
        try {
            const url = new URL(link);
            return url.pathname;
        } catch {
            return link;
        }
    }
    try {
        const url = new URL(link);
        const listToUse = internalUrlsSReach;
        if (listToUse.find((internalUrl) => url.host.includes(internalUrl))) {
            return url.pathname;
        }

        return link;
    } catch {
        return link;
    }
};
